__turbopack_context__.v({
  "grid": "RecipePairings-module-scss-module__8mZ6ua__grid",
  "headline": "RecipePairings-module-scss-module__8mZ6ua__headline",
  "section": "RecipePairings-module-scss-module__8mZ6ua__section",
});
